export const SERVICE_STATUS_EVENT = 'service-status-change';

export const markServiceAvailable = () => {
  window.dispatchEvent(
    new CustomEvent(SERVICE_STATUS_EVENT, {
      detail: {
        available: true,
        message: ''
      }
    })
  );
};

export const markServiceUnavailable = (message = 'Service is temporarily unavailable. Please try again in a moment.') => {
  window.dispatchEvent(
    new CustomEvent(SERVICE_STATUS_EVENT, {
      detail: {
        available: false,
        message
      }
    })
  );
};
